<template>
  <v-container fluid class="breadcrumbs-banner pa-0">
    <v-img src="/bannerlogo.svg" class="logo-banner">
      <v-container class="py-lg-5 px-10 px-sm-14 px-lg-3">
        <v-breadcrumbs
          :items="items"
          class="text-white px-0 pb-lg-2 breadcrumb-nav text-lg-body-1"
        >
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              :to="item.path"
              :disabled="item.disabled"
              exact
              class="text-white"
            >
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
        <h4
          class="text-white text-lg-h4 text-h5 font-weight-bold"
          v-html="bannerTitle"
        ></h4>
      </v-container>
    </v-img>
  </v-container>
</template>
<script>
export default {
  props: {
    bannerTitle: {
      required: true,
      type: String,
    },
  },
  created() {
    this.getRouteVisibleName();
  },
  data() {
    return {
      route: "",
    };
  },
  computed: {
    items() {
      return [
        {
          text: this.$t("header.home"),
          disabled: false,
          path: { name: "Home" },
        },
        {
          text: this.$t("header." + this.$route.matched[0].name),
          disabled: true,
        },
      ];
    },
  },
  methods: {
    getRouteVisibleName() {
      if (this.$route.meta.visible) {
        this.route = this.$route.name;
        let item = {
          text: this.$t("header." + this.route),
          disabled: true,
        };
        this.items.push(item);
      }
    },
  },
};
</script>